import { registerPlugin } from '@capacitor/core';

export type MetaAttributionIds = {
  /** Facebook App Events anonymous / install id. Do not hash for CAPI. */
  anonId: string | null;
  /** IDFA (iOS) or GAID (Android) when available. Do not hash for CAPI. */
  advertisingId: string | null;
  /** Whether advertiser tracking / ATT is enabled for Meta. */
  advertiserTrackingEnabled: boolean;
};

export interface MetaAttributionPlugin {
  getAttributionIds(): Promise<MetaAttributionIds>;
}

/**
 * Native implementation lives in
 * `systems/app-capacitor/plugins/capacitor-meta-attribution`. It is registered by
 * name here rather than imported as a package: `systems/` is outside the pnpm
 * workspace and is excluded from container build contexts, so a `file:` dependency
 * on it breaks `pnpm install` in the app-main image.
 *
 * The web fallback keeps browser builds working, where no Facebook SDK exists.
 */
export const MetaAttribution = registerPlugin<MetaAttributionPlugin>(
  'MetaAttribution',
  {
    web: () => ({
      getAttributionIds: async () => ({
        anonId: null,
        advertisingId: null,
        advertiserTrackingEnabled: false,
      }),
    }),
  },
);
